<template>
    <div class="container">
        <!--form-->
        <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" :model="queryForm" ref="queryForm">
            <el-form-item label="月份" prop="month">
                <el-date-picker
                        v-model="queryForm.month"
                        type="month"
                        placeholder="请选择月份">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetchData">查询</el-button>
                <el-button @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-card class="box-card mb20" style="background-color: #eaf5fc">
            <el-row>
                <el-col :span="8">
                    <div>
                        本月已入账
                    </div>
                    <p class="red f12">＋<span class="f20 plr2">{{summary.paidAmount || 0}}</span>元</p>
                    <p class="c6">实际{{summary.paidOrderSum}}单 补打款{{summary.paidDebtOrderSum}}单</p>
                </el-col>
                <el-col :span="8">
                    <div>
                        未打款金额
                    </div>
                    <p class="c1cb761 f12"><span class="f20 plr2">{{summary.unPaidAmount || 0}}</span>元</p>
                    <p class="c6">实际{{summary.unPaidOrderSum}}单 补打款{{summary.unPaidDebtOrderSum}}单</p>
                </el-col>
            </el-row>
        </el-card>
        <el-row class="pb20">
            <!--<div>-->
                <!--<el-button type="primary" @click="exportExcel()">导出</el-button>-->
                <!--<form name="downForm" method="get"></form>-->
            <!--</div>-->
            <export-excel :params="exportParams" :action="$apiUrl.financePayBill" :target="'finance'" :field="field" :filename="fileName" :fieldname="fieldName"></export-excel>
        </el-row>
        <div style="width: 100%;height: 910px;">
            <IEcharts :option="option" :loading="loading"></IEcharts>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import IEcharts from 'vue-echarts-v3';
    import ExportExcel from "../../components/exportExcel2.vue";

    export default {
        components: { IEcharts,ExportExcel },
        data() {
            return {
                queryFormLabelWidth: '100px',//自定义查询表单label宽度
                queryForm: {//查询表单数据
                    month: '',
                    startDate: '',
                    endDate: '',
                    commercial_id: '',
                    for_report: true
                },
                summary: {},

                //导出
                exportParams: {},
                fileName: '财务明细表',
                fieldName: ['日期','总收款流水','订单数（总）','退款订单数（总）','校方收款流水','订单数（校）','退款订单数（校）','公司收款流水','订单数（商）','退款订单数（商）','打款状态'],
                field: ['businessDate','totalCashFlow','totalOrderSum','totalRefundSum','schoolCashFlow','schoolOrderSum','schoolRefundSum','commercialCashFlow','commercialOrderSum','commercialRefundSum','billStatus'],

                loading: false,
                option: {
                    tooltip: {
                        formatter: function (params) {
                            if(params.value[2]){
                                let html = `总收款流水：${params.value[5]}元/${params.value[6]}单<br/>校方收款流水：${params.value[3]}元/${params.value[4]}单<br/>公司收款流水：${params.value[1]}元/${params.value[2]}单`;
                                return html;
                            }
                        }
                    },
                    visualMap: {
                        show: false,
                        min: 0,
                        max: 300,
                        calculable: true,
                        seriesIndex: [2],
                        orient: 'horizontal',
                        left: 'center',
                        bottom: 20,
                        inRange: {
                            color: ['#f5f5f5', '#f5f5f5'],
                            opacity: 0.5
                        },
                        controller: {
                            inRange: {
                                color: ['#fff', '#fff'],
                                opacity: 1
                            }
                        }
                    },
                    calendar: [{
                        left: 'center',
                        top: 'middle',
                        cellSize: [130, 130],
                        yearLabel: {show: false},
                        orient: 'vertical',
                        dayLabel: {
                            firstDay: 1,
                            nameMap: 'cn'
                        },
                        monthLabel: {
                            show: false
                        },
//                        range: ''
                    }],
                    series: [{
                        type: 'scatter',
                        coordinateSystem: 'calendar',
                        symbolSize: 1,
                        label: {
                            normal: {
                                show: true,
                                formatter: function (params) {
                                    if(moment(new Date()).format('YYYY-MM-DD') == params.value[0]){
                                        return params.value[0].substring(8,10) + "日\n\n今天";
                                    }
                                    return params.value[0].substring(8,10) + '日';
                                },
                                textStyle: {
                                    color: '#333'
                                }
                            }
                        },
                        data: []
                    }, {
                        type: 'scatter',
                        coordinateSystem: 'calendar',
                        symbolSize: 1,
                        label: {
                            normal: {
                                show: true,
                                formatter: function (params) {
                                    //return '\n\n\n' + (params.value[3] || '');
                                    let status = '';
                                    if(params.value[2]){
                                        if(params.value[2].billStatus){
                                            switch (params.value[2].billStatus) {
                                                case 0:
                                                    status = '未打款';
                                                    break;
                                                case 2:
                                                    status = '已打款';
                                                    break;
                                                case 8:
                                                    status = '已打款';
                                                    break;
                                            }
                                        }else{
//                                            status = '已打款';
                                            status = '未打款';
                                        }
                                    }
                                    return '\n\n\n' + status;
                                },
                                textStyle: {
                                    fontSize: 12,
                                    color: '#a00'
                                }
                            }
                        },
                        data: []
                    }, {
                        name: '明细',
                        type: 'heatmap',
                        coordinateSystem: 'calendar',
                        data: []
                    }]
                }

            }
        },
        created(){
            //默认显示最近一周
            this.queryForm.month = new Date();
            this.fetchData();
        },
        methods: {
            //抓取列表数据
            fetchData() {
                this.getSummary();
                this.getTableData();
            },
            getParams() {
                let params = {...this.queryForm};
                let month = parseInt(moment(params.month).format('MM'),10);
                let temp = new Date(moment(params.month).format('YYYY'),month,0);
                params.startDate = moment(params.month).format('YYYYMM') + '01';
                params.endDate = moment(params.month).format('YYYYMM') + temp.getDate();

                delete params.month;
                return params;
            },
            getSummary() {
                let params = this.getParams();
                this.$apiJava.post(this.$apiUrl.financePayBillSummary,params,(res)=>{
                    this.summary = res.data;
                },null,'finance')
            },
            getTableData() {
                let params = this.getParams();
                this.exportParams = {...params};
                this.exportParams.pageNo = 1;
                this.exportParams.pageSize = 99999;

                this.$apiJava.post(this.$apiUrl.financePayBill,params,(res)=>{
                    this.loading = false;
                    //this.tableData = res.data || [];
                    //得到该月所有日期
                    let month = parseInt(moment(this.queryForm.month).format('MM'),10);
                    let temp = new Date(moment(this.queryForm.month).format('YYYY'),month,0);
                    let lunarData = [];
                    let heatmapData = [];
                    for(var i=1;i<temp.getDate()+1;i++){
                        if(i<10) i = '0' + i;
                        lunarData.push([moment(this.queryForm.month).format('YYYY-MM-')+i,1]);
                        heatmapData.push([moment(this.queryForm.month).format('YYYY-MM-')+i,Math.random() * 300]);
                        if(res.data.length>0){
                            for(var j=0;j<res.data.length;j++){
                                if(res.data[j].businessDate && i == res.data[j].businessDate.substring(6,8)){
                                    lunarData.push([moment(this.queryForm.month).format('YYYY-MM-')+i,1,res.data[j]]);
                                    heatmapData.push([moment(this.queryForm.month).format('YYYY-MM-')+i,res.data[j].totalCashFlow,res.data[j].commercialOrderSum,res.data[j].schoolCashFlow,res.data[j].schoolOrderSum,res.data[j].totalCashFlow,res.data[j].totalOrderSum]);
                                }
                            }
                        }
                    }
                    this.option.calendar[0].range = moment(this.queryForm.month).format('YYYY-MM');
                    this.option.series[0].data = this.option.series[1].data = lunarData;
                    this.option.series[2].data = heatmapData;

                },(res)=>{
                    this.$message.warning(res.message);
//                    this.tableData = [];
                },'finance')
            },
            //表单重置 item上需要添加prop属性
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>
<style lang="scss"  scoped>
    .el-card{
        border: none;
        box-shadow: none;
    }
</style>



// WEBPACK FOOTER //
// pay.vue?3e336b9c